import React, {useRef} from "react";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import OfficeAppointments from "./officeAppointments";
import StoreAppointments from "./storeAppointments";

const DisplayAppointments = () => {
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const {isOffice} = customerSlotDetails.current;
  return isOffice ? <OfficeAppointments /> : <StoreAppointments />;
};

export default DisplayAppointments;
